export default __webpack_public_path__ + "static/media/Heart_product.38269786.png";